import isEmpty from 'lodash/isEmpty';

function calculateTotalAmount(tasks) {
  return tasks
    .reduce((a, b) => {
      if (b?.type === 'refund') {
        return a - Number(b.amount);
      }
      return a + Number(b.amount);
    }, 0)
    .toFixed(2)
    .toString();
}

export const getOrderTransactionData = (transactionItems, orderTask, isPlan) => {
  // order transactions
  const orderTransactions = transactionItems.filter(
    ({ orderItemUuid, type }) => orderItemUuid === orderTask.orderItemUuid && type === 'payment'
  );
  const refunds = transactionItems.filter(
    ({ orderItemUuid, type }) => orderItemUuid === orderTask.orderItemUuid && type === 'refund'
  );

  if (isEmpty(orderTransactions)) {
    return {
      cardUsed: '',
      orderTransaction: {},
      transactions: [],
      paymentStatus: 'Not Yet Available',
      totalAmount: '-'
    };
  }
  const relatedTransactions = transactionItems
    .filter(({ orderItemUuid }) => orderItemUuid === orderTransactions[0].orderItemUuid)
    .filter(({ amount }) => Number(amount) !== 0);

  const { cardType, cardLastFour } = orderTransactions[0];
  const cardUsed = `${(cardType ?? '').toUpperCase()} ${cardLastFour ?? ''}`.trim();
  const totalAmount = calculateTotalAmount(
    !isPlan ? [...orderTransactions, ...refunds] : relatedTransactions
  );
  return {
    cardUsed,
    orderTransaction: orderTransactions.find(({ description }) => !description?.includes('_off_')),
    transactions: relatedTransactions,
    paymentStatus: `Charged to ${cardUsed}`,
    totalAmount: totalAmount?.includes('-') ? `-$${totalAmount.split('-')[1]}` : `$${totalAmount}`
  };
};

function getItemsWithinBundle(orderTask, bundlesData) {
  const bundleContents = bundlesData.filter(
    (data) => data.relatedPlanPricing?.service === orderTask.orderTaskType
  );
  let contents = [];

  if (bundleContents.length > 0) {
    contents = bundleContents[0].contents || [];
  }

  // hack: dev has duplicate plans with different lengths of included content
  if (bundleContents.length > 1) {
    if (bundleContents[0].contents.length < bundleContents[1].contents.length) {
      contents = bundleContents[1].contents || [];
    }
  }

  // hack: remove duplicate services
  const normalizedContent = new Set(contents.map((c) => c.service));
  return Array.from(normalizedContent);
}

export function groupByBundles(orderTasks, bundlesData) {
  const bundles = new Set(
    bundlesData?.map(({ relatedPlanPricing }) => relatedPlanPricing?.service)
  );
  const bundlesInOrder = orderTasks?.filter((task) => bundles?.has(task.orderTaskType));
  const remainingTasks = orderTasks?.filter((task) => !bundles?.has(task.orderTaskType));
  const groupedTasks = [];

  bundlesInOrder.forEach((task) => {
    const contents = getItemsWithinBundle(task, bundlesData);
    const subtasks = [];

    contents.forEach((service) => {
      const index = remainingTasks.findIndex((orderTask) => orderTask.orderTaskType === service);

      if (index >= 0) {
        const subtask = remainingTasks.splice(index, 1);
        subtasks.push(subtask[0]);
      }
    });

    groupedTasks.push({
      task,
      subtasks
    });
  });

  remainingTasks.forEach((task) => {
    groupedTasks.push({
      task,
      subtasks: []
    });
  });

  return groupedTasks;
}
